import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IPointDetails } from 'app/shared/model/point-details.model';
import { getEntities as getPointDetails } from 'app/entities/point-details/point-details.reducer';
import { IAchievements } from 'app/shared/model/achievements.model';
import { getEntity, updateEntity, createEntity, reset } from './achievements.reducer';

export const AchievementsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pointDetails = useAppSelector(state => state.pointDetails.entities);
  const achievementsEntity = useAppSelector(state => state.achievements.entity);
  const loading = useAppSelector(state => state.achievements.loading);
  const updating = useAppSelector(state => state.achievements.updating);
  const updateSuccess = useAppSelector(state => state.achievements.updateSuccess);

  const handleClose = () => {
    navigate('/achievements' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPointDetails({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...achievementsEntity,
      ...values,
      pointDetails: pointDetails.find(it => it.id.toString() === values.pointDetails.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...achievementsEntity,
          pointDetails: achievementsEntity?.pointDetails?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fivePlusApp.achievements.home.createOrEditLabel" data-cy="AchievementsCreateUpdateHeading">
            <Translate contentKey="fivePlusApp.achievements.home.createOrEditLabel">Create or edit a Achievements</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="achievements-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fivePlusApp.achievements.name')}
                id="achievements-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.achievements.description')}
                id="achievements-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.achievements.feature')}
                id="achievements-feature"
                name="feature"
                data-cy="feature"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('fivePlusApp.achievements.requiredProof')}
                id="achievements-requiredProof"
                name="requiredProof"
                data-cy="requiredProof"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('fivePlusApp.achievements.displayName')}
                id="achievements-displayName"
                name="displayName"
                data-cy="displayName"
                type="text"
              />
              <ValidatedField
                id="achievements-pointDetails"
                name="pointDetails"
                data-cy="pointDetails"
                label={translate('fivePlusApp.achievements.pointDetails')}
                type="select"
              >
                <option value="" key="0" />
                {pointDetails
                  ? pointDetails.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/achievements" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AchievementsUpdate;
